import { call, put, all, takeEvery, select } from "redux-saga/effects";
import { userActions } from "../actions";
import { generalActions } from "../actions";
import api from "../services/user.service";
import authApi from "../services/auth.service";
import ACTIONS from "../constants";
import { rolesPagination, usersPagination } from "../selectors/user.selector";

//////////////////////////////////////////// USER ACCOUNT ////////////////////////////////////////////

function* resetPassword(state) {
  try {
    yield put(userActions.resetPasswordAttempt.pending);
    const password = yield call(api.updateUserPasswordRequest, state.payload);
    console.log("Success case", password);
    yield put(userActions.resetPasswordAttempt.success(password));
    yield put(
      generalActions.showToast({
        title: "Password updated",
        type: "success",
      })
    );
  } catch (error) {
    // if(error.status === 400) {
    //   yield put(
    //     generalActions.showToast({
    //       title: error.data.message,
    //       type: 'error',
    //     }),
    //   );
    // } else {
    //   const errorObject = JSON.parse(JSON.stringify(error));
    //   const errArr = [];
    //   for (const key in errorObject) {
    //     if (Object.hasOwnProperty.call(errorObject, key)) {
    //       const errorMessages = errorObject[key];
    //       errorMessages.forEach(errorMessage => {
    //         errArr.push(errorMessage)
    //       });
    //     }
    //   }
    //   yield put(
    //     generalActions.showToast({
    //       title: errArr[0],
    //       type: 'error',
    //     }),
    //   );
    // }
    // yield put(userActions.resetPasswordAttempt.error(error.message));
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 422) {
      yield put(userActions.resetPasswordAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(userActions.resetPasswordAttempt.error(errorObject.data));
      // yield put(userActions.resetPasswordAttempt.error(errorObject.data.errors[0].message));
    }
  }
}

function* profile(state) {
  try {
    yield put(userActions.userProfileAttempt.pending);
    const response = yield call(api.userDataRequest, state.payload);
    yield put(userActions.userProfileAttempt.success(response));
  } catch (error) {
    yield put(userActions.userProfileAttempt.error(error.message));
  }
}

function* updateProfile(state) {
  try {
    yield put(userActions.updateProfileDataAttempt.pending);
    yield call(api.updateUserDataRequest, state.payload);
    const id = yield localStorage.getItem("id");
    const user = yield call(api.userDataRequest, id);
    yield localStorage.setItem("user", JSON.stringify(user));
    yield put(userActions.updateProfileDataAttempt.success(user));
    yield put(
      generalActions.showToast({
        title: "User information saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (errorObject.status === 422) {
      yield put(userActions.updateProfileDataAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        userActions.updateProfileDataAttempt.error(errorObject.data.errors[0])
      );
      // yield put(userActions.updateProfileDataAttempt.error(errorObject.data.errors[0].message));
    }
    // const errArr = [];
    // for (const key in errorObject) {
    //   if (Object.hasOwnProperty.call(errorObject, key)) {
    //     const errorMessages = errorObject[key];
    //     errorMessages.forEach(errorMessage => {
    //       errArr.push(errorMessage)
    //     });
    //   }
    // }
    // yield console.log('========= Response =========', errArr)
    // yield put(
    //   generalActions.showToast({
    //     title: errArr,
    //     type: 'error',
    //   }),
    // );
    // for(let i = 0; i < errArr.length; i++) {
    //   yield put(
    //     generalActions.showToast({
    //       title: errArr[i],
    //       type: 'error',
    //     }),
    //   );
    // }

    // yield put(userActions.updateProfileDataAttempt.error(error.message));
  }
}

function* updateProfilePicture(state) {
  try {
    yield put(userActions.updateProfilePictureAttempt.pending);
    const Id = localStorage.getItem("id");
    state.payload.id = Id;
    const resp = yield call(api.updateUserPictureRequest, state.payload);
    if (resp.status === 400) {
      yield console.log("Error..", resp.data.message);
      yield put(
        generalActions.showToast({
          title: resp.data.message,
          type: "error",
        })
      );
      yield put(
        userActions.updateProfilePictureAttempt.error(resp.data.message)
      );
    } else {
      const id = yield localStorage.getItem("id");
      const user = yield call(api.userDataRequest, id);
      yield localStorage.setItem("user", JSON.stringify(user));
      yield put(userActions.updateProfilePictureAttempt.success(user));
      yield put(
        generalActions.showToast({
          title: "Profile picture updated",
          type: "success",
        })
      );
    }
  } catch (error) {
    yield put(userActions.updateProfilePictureAttempt.error(error.message));
  }
}

function* updateWorkingHours(state) {
  try {
    yield put(userActions.updateWorkingHoursAttempt.pending);
    yield call(api.updateWrkingHoursRequest, state.payload);
    const id = yield localStorage.getItem("id");
    const user = yield call(api.userDataRequest, id);
    if (user) yield localStorage.setItem("user", JSON.stringify(user));
    yield put(userActions.updateWorkingHoursAttempt.success(user));
    yield put(
      generalActions.showToast({
        title: "Working hours saved",
        type: "success",
      })
    );
  } catch (error) {
    yield put(userActions.updateWorkingHoursAttempt.error(error.message));
  }
}

function* getGroups(state) {
  try {
    yield put(userActions.getGroupsAttempt.pending);
    const groups = yield call(api.groupsRequest, state.payload);
    yield put(userActions.getGroupsAttempt.success(groups));
  } catch (error) {
    yield put(userActions.getGroupsAttempt.error(error.message));
  }
}

//////////////////////////////////////////// ROLES ////////////////////////////////////////////

function* getRoles(state) {
  try {
    yield put(userActions.getRolesAttempt.pending);
    const roles = yield call(api.rolesRequest, state.payload);
    const pagination = JSON.parse(roles.headers["x-pagination"]);
    const data = {
      data: roles.data,
      pagination: pagination,
    };
    if (roles.data)
      yield localStorage.setItem("roles", JSON.stringify(roles.data));
    yield put(userActions.getRolesAttempt.success(data));
  } catch (error) {
    if (
      error.message ===
      `Cannot read properties of undefined (reading 'x-pagination')`
    ) {
      yield put(userActions.getRolesAttempt.error(""));
    } else {
      yield put(userActions.getRolesAttempt.error(error.message));
    }
  }
}

function* createRole(state) {
  try {
    yield put(userActions.createRoleAttempt.pending);
    const role = yield call(api.createRoleRequest, state.payload.payload);
    localStorage.setItem("selectedRow", JSON.stringify(role));
    // const paginat = yield select(rolesPagination);
    const roles = yield call(api.rolesRequest, {
      page: 1,
      size: state.payload.perPageItems,
    });
    const pagination = JSON.parse(roles.headers["x-pagination"]);
    const data = {
      data: roles.data,
      pagination: pagination,
    };
    if (roles.data)
      yield localStorage.setItem("roles", JSON.stringify(roles.data));
    yield put(userActions.createRoleAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Role saved",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(userActions.createRoleAttempt.error(errorObject));
      } else {
        yield put(
          userActions.createRoleAttempt.error(errorObject.data.Name[0])
        );
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(userActions.createRoleAttempt.error(errorObject.data.Name[0]));
    }
    if (errorObject.status === 400) {
      yield put(
        userActions.createRoleAttempt.error(errorObject.data.errors[0].message)
      );
    }
  }
}

function* updateRole(state) {
  try {
    yield put(userActions.updateRoleAttempt.pending);
    yield call(api.updateRoleRequest, state.payload);
    const paginat = yield select(rolesPagination);
    const roles = yield call(api.rolesRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(roles.headers["x-pagination"]);
    const data = {
      data: roles.data,
      pagination: pagination,
    };
    if (roles.data)
      yield localStorage.setItem("roles", JSON.stringify(roles.data));
    yield put(userActions.updateRoleAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Role updated",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(userActions.updateRoleAttempt.error(errorObject));
      } else {
        yield put(
          userActions.updateRoleAttempt.error(errorObject.data.Name[0])
        );
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }

    if (errorObject.status === 422) {
      yield put(userActions.updateRoleAttempt.error(errorObject.data.Name[0]));
    }
    if (errorObject.status === 400) {
      yield put(
        userActions.updateRoleAttempt.error(errorObject.data.errors[0].message)
      );
    }
  }
}

function* deleteRole(state) {
  try {
    yield put(userActions.deleteRoleAttempt.pending);
    yield call(api.deleteRoleRequest, state.payload);
    const paginat = yield select(rolesPagination);
    const roles = yield call(api.rolesRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(roles.headers["x-pagination"]);
    const data = {
      data: roles.data,
      pagination: pagination,
    };
    if (roles.data)
      yield localStorage.setItem("roles", JSON.stringify(roles.data));
    yield put(userActions.deleteRoleAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Role deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(userActions.deleteRoleAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }

    if (error.status === 400) {
      yield put(userActions.deleteRoleAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error.data.message}`,
          type: "Error",
        })
      );
    } else {
      yield put(userActions.deleteRoleAttempt.error(error));
      yield put(
        generalActions.showToast({
          title: `${error}`,
          type: "Error",
        })
      );
    }
  }
}

function* sortRoles(state) {
  try {
    yield put(userActions.sortRolesRequestAttempt.pending);
    const roles = yield call(api.sortRolesRequest, state.payload);
    const pagination = JSON.parse(roles.headers["x-pagination"]);
    const data = {
      data: roles.data,
      pagination: pagination,
    };
    yield put(userActions.sortRolesRequestAttempt.success(data));
  } catch (error) {
    yield put(userActions.sortRolesRequestAttempt.error(error));
  }
}

function* updateRoleFlag(state) {
  try {
    yield put(userActions.updateRoleFlagAttempt.pending);
    yield call(api.updateRoleFlagRequest, state.payload);
    yield put(userActions.updateRoleFlagAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Roles flag updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    yield put(userActions.updateRoleFlagAttempt.error(error));
  }
}

//////////////////////////////////////////// PERMISSIONS ////////////////////////////////////////////

function* getPermissions(state) {
  try {
    yield put(userActions.getPermissionsAttempt.pending);
    const permissions = yield call(
      authApi.rolePermissionsRequest,
      state.payload
    );
    yield put(userActions.getPermissionsAttempt.success(permissions));
  } catch (error) {
    yield put(userActions.getPermissionsAttempt.error(error.message));
  }
}

function* updatePermissions(state) {
  try {
    yield put(userActions.updaterolePermissionsAttempt.pending);
    yield call(api.updatePermissionsRequest, state.payload);
    const permissions = yield call(authApi.selfPermissionsRequest);
    if (permissions)
      yield localStorage.setItem(
        "permissions",
        JSON.stringify(permissions.permissions)
      );
    yield put(userActions.updaterolePermissionsAttempt.success());
    yield put(
      generalActions.showToast({
        title: "Permissions saved",
        type: "success",
      })
    );
  } catch (error) {
    yield put(userActions.updaterolePermissionsAttempt.error(error.message));
  }
}

//////////////////////////////////////////// USERS ////////////////////////////////////////////

function* getUsers(state) {
  try {
    yield put(userActions.getUsersAttempt.pending);
    const users = yield call(authApi.usersRequest, state.payload);
    if (users.headers) {
      const pagination = JSON.parse(users.headers["x-pagination"]);
      const data = {
        data: users.data,
        pagination: pagination,
      };
      yield put(userActions.getUsersAttempt.success(data));
    } else {
      const data = {
        data: users,
        pagination: {},
      };
      yield put(userActions.getUsersAttempt.success(data));
    }
  } catch (error) {
    yield put(userActions.getUsersAttempt.error(error.message));
  }
}

function* updateUserStatus(state) {
  try {
    yield put(userActions.updateUserStatusAttempt.pending);
    const status = state?.payload?.payload?.isActive;
    yield call(authApi.userStatusUpdateRequest, state.payload);
    const paginat = yield select(usersPagination);
    const users = yield call(authApi.usersRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(users.headers["x-pagination"]);
    const data = {
      data: users.data,
      pagination: pagination,
    };
    yield put(userActions.updateUserStatusAttempt.success(data));

    yield put(
      generalActions.showToast({
        title: `User ${status ? "activated" : "deactivated"} successfully`,
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
      yield put(userActions.updateUserStatusAttempt.error(error.message));
    }

    if (errorObject.status === 422) {
      yield put(userActions.updateUserStatusAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(userActions.updateUserStatusAttempt.error(error.message));
    }
  }
}

function* createUser(state) {
  try {
    yield put(userActions.createUserAttempt.pending);
    yield call(authApi.userCreateRequest, state.payload);
    const paginat = yield select(usersPagination);
    const users = yield call(authApi.usersRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(users.headers["x-pagination"]);
    const data = {
      data: users.data,
      pagination: pagination,
    };
    yield put(userActions.createUserAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "User created successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(userActions.createUserAttempt.error(errorObject));
      } else {
        yield put(userActions.createUserAttempt.error(errorObject.data));
      }
      yield put(userActions.createUserAttempt.error(errorObject.data));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(userActions.createUserAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        userActions.createUserAttempt.error(errorObject.data.errors[0].message)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
      //
    }
  }
}

function* updateUser(state) {
  try {
    yield put(userActions.updateUserAttempt.pending);
    yield call(authApi.userUpdateRequest, state.payload);
    const paginat = yield select(usersPagination);
    const users = yield call(authApi.usersRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(users.headers["x-pagination"]);
    const data = {
      data: users.data,
      pagination: pagination,
    };
    yield put(userActions.updateUserAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "User updated successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      if (typeof errorObject === "string") {
        yield put(userActions.updateUserAttempt.error(errorObject));
      } else {
        yield put(userActions.updateUserAttempt.error(errorObject.data));
      }
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(userActions.updateUserAttempt.error(errorObject.data));
    }
    if (errorObject.status === 400) {
      yield put(
        userActions.updateUserAttempt.error(errorObject.data.errors[0].message)
      );
      yield put(
        generalActions.showToast({
          title: errorObject.data.errors[0].message,
          type: "error",
        })
      );
    }
  }
}

function* deleteUser(state) {
  try {
    yield put(userActions.deleteUserAttempt.pending);
    yield call(authApi.userDeleteRequest, state.payload);
    const paginat = yield select(usersPagination);
    const users = yield call(authApi.usersRequest, {
      page: paginat.CurrentPage,
      size: paginat.PageSize,
    });
    const pagination = JSON.parse(users.headers["x-pagination"]);
    const data = {
      data: users.data,
      pagination: pagination,
    };
    yield put(userActions.deleteUserAttempt.success(data));
    yield put(
      generalActions.showToast({
        title: "Deleted successfully",
        type: "success",
      })
    );
  } catch (error) {
    const errorObject = JSON.parse(JSON.stringify(error));
    if (
      errorObject.status === 500 ||
      errorObject.status === 502 ||
      errorObject === "Network Error!"
    ) {
      yield put(userActions.deleteUserAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: "Something went wrong. Please try again later.",
          type: "error",
        })
      );
    }
    if (errorObject.status === 422) {
      yield put(userActions.deleteUserAttempt.error(error.message));
    }
    if (errorObject.status === 400) {
      yield put(userActions.deleteUserAttempt.error(error.message));
      yield put(
        generalActions.showToast({
          title: errorObject?.data?.message || errorObject.data?.errors[0]?.message,
          type: "error",
        })
      );
    }
  }
}

function* sortResources(state) {
  try {
    yield put(userActions.sortResourceRequestAttempt.pending);
    const users = yield call(api.sortUsersRequest, state.payload);
    const pagination = JSON.parse(users.headers["x-pagination"]);
    const data = {
      data: users.data,
      pagination: pagination,
    };
    yield put(userActions.sortResourceRequestAttempt.success(data));
  } catch (error) {
    yield put(userActions.sortResourceRequestAttempt.error(error));
  }
}

function* updateUserFlag(state) {
  try {
    yield put(userActions.updateUserFlagAttempt.pending);
    yield call(api.updateUserFlagRequest, state.payload);
    yield put(userActions.updateUserFlagAttempt.success());
  } catch (error) {
    yield put(userActions.updateUserFlagAttempt.error(error));
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(ACTIONS.USER_RESET_PASSWORD_CALL, resetPassword),
    takeEvery(ACTIONS.USER_PROFILE_CALL, profile),
    takeEvery(ACTIONS.UPDATE_USER_PROFILE_CALL, updateProfile),
    takeEvery(ACTIONS.UPDATE_USER_PROFILE_PICTURE_CALL, updateProfilePicture),
    takeEvery(ACTIONS.UPDATE_WORKING_HOURS_CALL, updateWorkingHours),
    takeEvery(ACTIONS.CREATE_ROLE_CALL, createRole),
    takeEvery(ACTIONS.UPDATE_ROLE_CALL, updateRole),
    takeEvery(ACTIONS.SORT_ROLES_CALL, sortRoles),
    takeEvery(ACTIONS.ROLES_CALL, getRoles),
    takeEvery(ACTIONS.DELETE_ROLE_CALL, deleteRole),
    takeEvery(ACTIONS.ROLES_FLAG_CALL, updateRoleFlag),
    takeEvery(ACTIONS.PERMISSIONS_CALL, getPermissions),
    takeEvery(ACTIONS.UPDATE_PERMISSIONS_CALL, updatePermissions),
    takeEvery(ACTIONS.USERS_CALL, getUsers),
    takeEvery(ACTIONS.UPDATE_USER_STATUS_CALL, updateUserStatus),
    takeEvery(ACTIONS.CREATE_USER_CALL, createUser),
    takeEvery(ACTIONS.UPDATE_USER_CALL, updateUser),
    takeEvery(ACTIONS.DELETE_USER_CALL, deleteUser),
    takeEvery(ACTIONS.USER_FLAG_CALL, updateUserFlag),
    takeEvery(ACTIONS.SORT_USERS_CALL, sortResources),
    takeEvery(ACTIONS.GROUPS_CALL, getGroups),
  ]);
}
